import OnepageCheckoutCustomNotesState from "@sunSource/Store/Data/OnePageCheckoutCustomNotes/OnePageCheckoutCustomNotesState";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { Draft } from "immer";

const initialState = {
    isPaymentMethodName: "",
};

const reducer = {
    "Pages/OnePageCheckout/payementName": (
        draft: Draft<OnepageCheckoutCustomNotesState>,
        action: { isPaymentMethodName: string | undefined | "" },
    ) => {
        draft.isPaymentMethodName = action.isPaymentMethodName;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
